/**
 * ============================================================================
 * KpiMiniCard — small KPI tile rendered alongside each HELD review on the
 * ReviewCalendar. Read-only; the detail panel is on /management-reviews/:id.
 * Owner: Phase 7 — Management Review Module (Agent F).
 * ============================================================================
 */

import styles from './ReviewCalendar.module.css';

export interface KpiMiniCardProps {
  label: string;
  value: number | string;
}

export function KpiMiniCard({ label, value }: KpiMiniCardProps) {
  return (
    <div className={styles.kpiTile} role="figure" aria-label={`KPI ${label}`}>
      <div className={styles.kpiLabel}>{label}</div>
      <div className={styles.kpiValue}>{value}</div>
    </div>
  );
}
